<template>
  <div v-loading="loading" class="frame" element-loading-text="加载中...">
    <iframe ref="frameRef" :src="frameSrc" class="frame-iframe" />
  </div>
</template>
<script setup>
import { useRoute, useRouter } from "vue-router";
import { ref, unref, toRaw, watch, onMounted, nextTick } from "vue";
import { getToken } from "@/utils/auth";
import store from "@/store";
import { ElMessage } from "element-plus";
defineOptions({
  name: "LayFrame",
});

const props = defineProps({
  frameInfo: Object,
});

const loading = ref(true);
const router = useRouter();
const currentRoute = useRoute();
const frameSrc = ref("");
const frameRef = ref(null);
if (unref(currentRoute.meta)?.frameSrc) {
  frameSrc.value = unref(currentRoute.meta)?.frameSrc;
}

unref(currentRoute.meta)?.frameLoading === false && hideLoading();
function hideLoading() {
  loading.value = false;
}
function sendIframeMessage() {
  const iframe = unref(frameRef);
  let userInfo = store.getters.userInfo;
  userInfo = toRaw(userInfo);
  console.log("userInfo===>", userInfo);
  //children  frongRoute

  let menuTree = userInfo.menuTree[0].children.find(
    (ele) => ele.frongRoute === "/smartPlant"
  );
  menuTree = menuTree.children ? menuTree.children : [];
  if (menuTree.length) {
    let parmas = {
      token: getToken(),
      menuTree: menuTree,
    };
    console.log("发送参数====>", parmas);
    console.log("发送参数2====>", iframe);
    iframe.contentWindow.postMessage(parmas, "*");
  } else {
    ElMessage({
      message: "厂站暂无菜单,请配置厂站菜单",
      type: "error",
    });
    router.go(-1);
  }
}
watch(
  () => currentRoute.fullPath,
  (path) => {
    if (
      currentRoute.name === "Redirect" &&
      path.includes(props.frameInfo?.fullPath)
    ) {
      frameSrc.value = path; // redirect时，置换成任意值，待重定向后 重新赋值
      loading.value = true;
    }
    // 重新赋值
    if (props.frameInfo?.fullPath === path) {
      frameSrc.value = props.frameInfo?.frameSrc;
    }
  }
);

onMounted(() => {
  init();
  window.addEventListener("message", function (e) {
    // console.log("接受参数====>", e);
    if (e.data?.type === "LogOut") {
      store.dispatch("userInfo/LogOut").then(() => {
        store.commit("permission/SET_SUB_SYSTEM_NAME", "");
        store.commit("permission/SET_ROUTE_TABS", []);
        store.commit("permission/SET_SUB_SYSTEM_ID", "");
        router.replace("/login");
      });
    } else if (e.data?.type === "turnBack") {
      router.push("/entrance");
    }
  });
});

function init() {
  nextTick(() => {
    const iframe = unref(frameRef);

    if (!iframe) return;

    const _frame = iframe;
    if (_frame.attachEvent) {
      _frame.attachEvent("onload", () => {
        hideLoading();
        sendIframeMessage();
      });
    } else {
      iframe.onload = () => {
        hideLoading();
        sendIframeMessage();
      };
    }
  });
}
</script>

<style lang="scss" scoped>
.frame {
  position: absolute;
  inset: 0;
  overflow: hidden;
  .frame-iframe {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 0;
  }
}
</style>
